function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#878890",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M382.038 27c-.479 0-.888.339-.98.809l-.334 1.714c-.82.31-1.58.744-2.246 1.291l-1.645-.566c-.453-.156-.951.031-1.191.445l-1.508 2.614c-.239.415-.152.941.21 1.255l1.317 1.147c-.068.421-.113.85-.113 1.291 0 .44.045.87.113 1.291l-1.318 1.147c-.36.313-.448.84-.209 1.255l1.508 2.614c.239.415.738.602 1.191.447l1.645-.566c.666.546 1.426.978 2.246 1.289l.334 1.714c.092.47.501.809.98.809h3.02c.479 0 .888-.339.98-.809l.334-1.714c.821-.31 1.58-.744 2.246-1.291l1.645.566c.453.156.951-.03 1.191-.445l1.508-2.616c.24-.415.152-.94-.209-1.254l-1.318-1.146c.068-.421.113-.85.113-1.291 0-.44-.045-.87-.113-1.291l1.318-1.147c.361-.313.448-.84.21-1.255l-1.509-2.614c-.239-.415-.738-.602-1.191-.447l-1.645.567c-.666-.547-1.425-.98-2.246-1.29l-.334-1.714c-.092-.47-.501-.809-.98-.809h-3.02zm1.51 6c2.21 0 4 1.791 4 4s-1.79 4-4 4c-2.209 0-4-1.791-4-4s1.791-4 4-4z",
  transform: "translate(-374 -27)"
})));

var SvgGear = function SvgGear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gear.5eb58678.svg";
export { ForwardRef as ReactComponent };